import React, { useEffect } from 'react';
import AppRouter  from './router';
import { deviceId } from 'utils/DeviceIdUtil';
import {onPageStart} from 'utils'

function App() {
	window.androidData = window.MobileApp ? JSON.parse(window.MobileApp.getAppSpecificData()) : {}
	useEffect(()=>{
       deviceId()
	   onPageStart('CT_LANDING_PAGE')
	},[])
	return (
		<div className='flex flex-column' style={{ minHeight: '100vh' }}>
			<AppRouter />
		</div>
	);
}

export default App;
